import React, { useEffect, useState } from "react"

import "./AllPost.css"
import _ from "lodash"
import {
  collection,
  getDocs,
  query,
  where,
  setDoc,
  doc,
} from "firebase/firestore"
import { db, storage } from "../../Firebase/Firebase-config"
import {
  ref,
  listAll,
  getDownloadURL,
  uploadBytes,
  storageRef,
} from "firebase/storage"
import moment from "moment/moment"
import loading from "../../asserts/skeltonLoading.gif"
import { useNavigate } from "react-router-dom"

const AllPost = () => {
  const navigate = useNavigate()
  const [allBlogs, setAllBlogs] = useState([])
  const dbCollectionRef = collection(db, "blogs")
  const imageListRef = ref(storage, "blog-images/")

  async function addImages() {
    listAll(imageListRef).then((res) => {
      res.items.forEach((item) => {
        getDownloadURL(item).then((url) => {
          // const index = allBlogs.map((blog) =>
          //   _.isEqual(blog.thumbnail, item.name)
          // )
          for (let i = 0; i < allBlogs.length; i++) {
            const find = _.isEqual(allBlogs[i].thumbnail, item.name)
            if (find) {
              setAllBlogs((prevAllBlogs) =>
                prevAllBlogs.map((blog) => ({ ...blog, url: url }))
              )
              console.log(url)
            } else {
              setAllBlogs((prevAllBlogs) =>
                prevAllBlogs.map((blog) => ({ ...blog, url: "" }))
              )
            }
          }
        })
      })
    })

    console.log(allBlogs)
  }

  async function getAllBlogs() {
    const q = query(
      dbCollectionRef,
      where("delete", "==", false)
      // where("date", "<=", moment().format("DD-MM-YYYY hh:mm:ss"))
    )
    const data = await getDocs(q)
    setAllBlogs(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
    addImages()

    // for(let i in allBlogs){
    //   const momentDate = moment(allBlogs[i].date, 'DD-MM-YYYY').format('DD-MM-YYYY')
    //   const current = moment()
    //   console.log(moment(momentDate).isAfter(current));
    //   if (moment(momentDate).isBefore(current)) {
    //     console.log(true);
    //   }
    // }
  }

  useEffect(() => {
    getAllBlogs()
  }, [allBlogs.length])

  return (
    <div className="all-post-container">
      {allBlogs &&
        allBlogs.map((items) => {
          return (
            <div
              className="all-post-postbox hover:cursor-pointer"
              key={items.id}
              onClick={() => {
                navigate(`../blog/${items.id}`)
              }}
            >
              <div className="img-container">
                <img src={items.url ? items.url : loading} alt="blog-image" />
              </div>
              <div className="post-content">
                <div className="time-share">
                  <div>{moment(items.date).format("DD-MMMM-YYYY")}</div>
                  <div className="share-post">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 32 32"
                      id="share"
                    >
                      <path d="M25,20a5,5,0,0,0-3.91,1.93l-9.28-4.64A5,5,0,0,0,12,16a5,5,0,0,0-.19-1.29l9.28-4.64A5,5,0,0,0,25,12a5,5,0,1,0-5-5,5,5,0,0,0,.19,1.29l-9.28,4.64A5,5,0,0,0,7,11,5,5,0,0,0,7,21a5,5,0,0,0,3.91-1.93l9.28,4.64A5,5,0,1,0,25,20ZM25,4a3,3,0,1,1-3,3A3,3,0,0,1,25,4ZM7,19a3,3,0,1,1,3-3A3,3,0,0,1,7,19Zm18,9a3,3,0,1,1,3-3A3,3,0,0,1,25,28Z"></path>
                    </svg>
                  </div>
                </div>
                <div className="blog-title">{items.tittle}</div>
                <div className="blog-body">
                  {_.truncate(items.description, {
                    length: 600,
                    separator: " ",
                    omission: ".....",
                  })}
                </div>
              </div>
            </div>
          )
        })}

      {/* <div className="all-post-postbox">
        <div className="img-container">
          <img
            src="https://static.wixstatic.com/media/75059a_19d50c96541b4b1aa915d498b351bd17~mv2.jpg/v1/fill/w_365,h_479,fp_0.50_0.50,q_90,enc_auto/75059a_19d50c96541b4b1aa915d498b351bd17~mv2.jpg"
            alt="blog-img"
          />
        </div>
        <div className="post-content">
          <div className="time-share">
            <div>Mar 22 2 min</div>
            <div className="share-post">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
                id="share"
              >
                <path d="M25,20a5,5,0,0,0-3.91,1.93l-9.28-4.64A5,5,0,0,0,12,16a5,5,0,0,0-.19-1.29l9.28-4.64A5,5,0,0,0,25,12a5,5,0,1,0-5-5,5,5,0,0,0,.19,1.29l-9.28,4.64A5,5,0,0,0,7,11,5,5,0,0,0,7,21a5,5,0,0,0,3.91-1.93l9.28,4.64A5,5,0,1,0,25,20ZM25,4a3,3,0,1,1-3,3A3,3,0,0,1,25,4ZM7,19a3,3,0,1,1,3-3A3,3,0,0,1,7,19Zm18,9a3,3,0,1,1,3-3A3,3,0,0,1,25,28Z"></path>
              </svg>
            </div>
          </div>
          <div className="blog-title">
            Transform your winter blues into winter creativity
          </div>
          <div className="blog-body">
            Create a blog post subtitle that summarizes your post in a few
            short, punchy sentences and entices your audience to ...
          </div>
        </div>
      </div>
      <div className="all-post-postbox">
        <div className="img-container">
          <img
            src="https://static.wixstatic.com/media/75059a_cf2c39f511b6478eaea5b4f7713831c0~mv2.jpg/v1/fill/w_365,h_265,fp_0.50_0.50,q_90,enc_auto/75059a_cf2c39f511b6478eaea5b4f7713831c0~mv2.jpg"
            alt="blog-img"
          />
        </div>
        <div className="post-content">
          <div className="time-share">
            <div>Mar 22 2 min</div>
            <div className="share-post">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
                id="share"
              >
                <path d="M25,20a5,5,0,0,0-3.91,1.93l-9.28-4.64A5,5,0,0,0,12,16a5,5,0,0,0-.19-1.29l9.28-4.64A5,5,0,0,0,25,12a5,5,0,1,0-5-5,5,5,0,0,0,.19,1.29l-9.28,4.64A5,5,0,0,0,7,11,5,5,0,0,0,7,21a5,5,0,0,0,3.91-1.93l9.28,4.64A5,5,0,1,0,25,20ZM25,4a3,3,0,1,1-3,3A3,3,0,0,1,25,4ZM7,19a3,3,0,1,1,3-3A3,3,0,0,1,7,19Zm18,9a3,3,0,1,1,3-3A3,3,0,0,1,25,28Z"></path>
              </svg>
            </div>
          </div>
          <div className="blog-title">
            Transform your winter blues into winter creativity
          </div>
          <div className="blog-body">
            Create a blog post subtitle that summarizes your post in a few
            short, punchy sentences and entices your audience to ...
          </div>
        </div>
      </div>
      <div className="all-post-postbox">
        <div className="img-container">
          <img
            src="https://static.wixstatic.com/media/a27d24_77c3bdd084c14f50a13aa9b44485c2e3~mv2.jpg/v1/fill/w_365,h_510,fp_0.50_0.50,q_90,enc_auto/a27d24_77c3bdd084c14f50a13aa9b44485c2e3~mv2.jpg"
            alt="blog-img"
          />
        </div>
        <div className="post-content">
          <div className="time-share">
            <div>Mar 22 2 min</div>
            <div className="share-post">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
                id="share"
              >
                <path d="M25,20a5,5,0,0,0-3.91,1.93l-9.28-4.64A5,5,0,0,0,12,16a5,5,0,0,0-.19-1.29l9.28-4.64A5,5,0,0,0,25,12a5,5,0,1,0-5-5,5,5,0,0,0,.19,1.29l-9.28,4.64A5,5,0,0,0,7,11,5,5,0,0,0,7,21a5,5,0,0,0,3.91-1.93l9.28,4.64A5,5,0,1,0,25,20ZM25,4a3,3,0,1,1-3,3A3,3,0,0,1,25,4ZM7,19a3,3,0,1,1,3-3A3,3,0,0,1,7,19Zm18,9a3,3,0,1,1,3-3A3,3,0,0,1,25,28Z"></path>
              </svg>
            </div>
          </div>
          <div className="blog-title">
            Transform your winter blues into winter creativity
          </div>
          <div className="blog-body">
            Create a blog post subtitle that summarizes your post in a few
            short, punchy sentences and entices your audience to ...
          </div>
        </div>
      </div>
      <div className="all-post-postbox">
        <div className="img-container">
          <img
            src="https://static.wixstatic.com/media/75059a_3a3953ba8daa4a419562db4e61c7bee7~mv2.jpg/v1/fill/w_365,h_548,fp_0.50_0.50,q_90,enc_auto/75059a_3a3953ba8daa4a419562db4e61c7bee7~mv2.jpg"
            alt="blog-img"
          />
        </div>
        <div className="post-content">
          <div className="time-share">
            <div>Mar 22 2 min</div>
            <div className="share-post">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
                id="share"
              >
                <path d="M25,20a5,5,0,0,0-3.91,1.93l-9.28-4.64A5,5,0,0,0,12,16a5,5,0,0,0-.19-1.29l9.28-4.64A5,5,0,0,0,25,12a5,5,0,1,0-5-5,5,5,0,0,0,.19,1.29l-9.28,4.64A5,5,0,0,0,7,11,5,5,0,0,0,7,21a5,5,0,0,0,3.91-1.93l9.28,4.64A5,5,0,1,0,25,20ZM25,4a3,3,0,1,1-3,3A3,3,0,0,1,25,4ZM7,19a3,3,0,1,1,3-3A3,3,0,0,1,7,19Zm18,9a3,3,0,1,1,3-3A3,3,0,0,1,25,28Z"></path>
              </svg>
            </div>
          </div>
          <div className="blog-title">
            Transform your winter blues into winter creativity
          </div>
          <div className="blog-body">
            Create a blog post subtitle that summarizes your post in a few
            short, punchy sentences and entices your audience to ...
          </div>
        </div>
      </div>
      <div className="all-post-postbox">
        <div className="img-container">
          <img
            src="https://static.wixstatic.com/media/75059a_cf2c39f511b6478eaea5b4f7713831c0~mv2.jpg/v1/fill/w_365,h_265,fp_0.50_0.50,q_90,enc_auto/75059a_cf2c39f511b6478eaea5b4f7713831c0~mv2.jpg"
            alt="blog-img"
          />
        </div>
        <div className="post-content">
          <div className="time-share">
            <div>Mar 22 2 min</div>
            <div className="share-post">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
                id="share"
              >
                <path d="M25,20a5,5,0,0,0-3.91,1.93l-9.28-4.64A5,5,0,0,0,12,16a5,5,0,0,0-.19-1.29l9.28-4.64A5,5,0,0,0,25,12a5,5,0,1,0-5-5,5,5,0,0,0,.19,1.29l-9.28,4.64A5,5,0,0,0,7,11,5,5,0,0,0,7,21a5,5,0,0,0,3.91-1.93l9.28,4.64A5,5,0,1,0,25,20ZM25,4a3,3,0,1,1-3,3A3,3,0,0,1,25,4ZM7,19a3,3,0,1,1,3-3A3,3,0,0,1,7,19Zm18,9a3,3,0,1,1,3-3A3,3,0,0,1,25,28Z"></path>
              </svg>
            </div>
          </div>
          <div className="blog-title">
            Transform your winter blues into winter creativity
          </div>
          <div className="blog-body">
            Create a blog post subtitle that summarizes your post in a few
            short, punchy sentences and entices your audience to ...
          </div>
        </div>
      </div>
      <div className="all-post-postbox">
        <div className="img-container">
          <img
            src="https://static.wixstatic.com/media/75059a_9f8cd2f1282c4dc7ae9a4bea155e2661~mv2.jpg/v1/fill/w_365,h_469,fp_0.50_0.50,q_90,enc_auto/75059a_9f8cd2f1282c4dc7ae9a4bea155e2661~mv2.jpg"
            alt="blog-img"
          />
        </div>
        <div className="post-content">
          <div className="time-share">
            <div>Mar 22 2 min</div>
            <div className="share-post">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
                id="share"
              >
                <path d="M25,20a5,5,0,0,0-3.91,1.93l-9.28-4.64A5,5,0,0,0,12,16a5,5,0,0,0-.19-1.29l9.28-4.64A5,5,0,0,0,25,12a5,5,0,1,0-5-5,5,5,0,0,0,.19,1.29l-9.28,4.64A5,5,0,0,0,7,11,5,5,0,0,0,7,21a5,5,0,0,0,3.91-1.93l9.28,4.64A5,5,0,1,0,25,20ZM25,4a3,3,0,1,1-3,3A3,3,0,0,1,25,4ZM7,19a3,3,0,1,1,3-3A3,3,0,0,1,7,19Zm18,9a3,3,0,1,1,3-3A3,3,0,0,1,25,28Z"></path>
              </svg>
            </div>
          </div>
          <div className="blog-title">
            Transform your winter blues into winter creativity
          </div>
          <div className="blog-body">
            Create a blog post subtitle that summarizes your post in a few
            short, punchy sentences and entices your audience to ...
          </div>
        </div>
      </div> */}
    </div>
  )
}

export default AllPost
